// extracted by mini-css-extract-plugin
module.exports = {"section":"Gen3D_section__SFY72","gen3":"Gen3D_gen3__2JHJ_","gen3d_title":"Gen3D_gen3d_title__rz_5e"};